"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CATEGORY_BOX_SKELETON = void 0;
const CATEGORY_BOX_SKELETON = exports.CATEGORY_BOX_SKELETON = 'category-box-skeleton';
